import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pickMeasures, proposeMeasure } from '../../api/workEnvironmentQueries';
import type { ProposalRequest } from '../../api/workEnvironmentTypes';
import { TeamMeasuresQueryKey } from '../queries/useWorkEnvironmentMeasuresQuery';

export const useProposeMeasureMutation = (uuid: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: ProposalRequest) => proposeMeasure(uuid, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [TeamMeasuresQueryKey, uuid] }),
  });
};

export const usePickMeasuresMutation = (uuid: string, token: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (proposalIds: number[]) => pickMeasures(uuid, token, proposalIds),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [TeamMeasuresQueryKey, uuid] }),
  });
};
